import { FC, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

export const Main: FC<IProps> = ({ children }) => {
  return <main className="w-full min-h-screen">{children}</main>;
};
